const CLASS_NAMES = {
  menu_item_active: 'menu__item--active',
};

const SELECTORS = {
  zoomable_images: 'img:not(.image--no-zoom)',
  /* menu */
  menu_items_id: ['case-studies', 'sneak-peek', 'resume', 'contact'],
  menu_item: '.menu__item',
  menu_item_active: `.${CLASS_NAMES.menu_item_active}`,
};

export { SELECTORS, CLASS_NAMES };
